import { render, staticRenderFns } from "./OpenImmo.vue?vue&type=template&id=7b7af7c0&"
import script from "./OpenImmo.vue?vue&type=script&lang=js&"
export * from "./OpenImmo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports